import { useEffect } from "react";
import { t } from "i18next";

import { Button, Card } from "react-bootstrap";
import useDetailsAction from "../actions/details/useDetailsAction";

function DetailsPage(props: { modelConfig: any; templates?: [] }) {
  const { modelConfig, templates } = props;

  const id = 1;

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate: detailsActionTemplate,
  } = useDetailsAction(modelConfig, id);

  useEffect(() => {
    getFunction(id);
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-xl-12 col-12">
          <div className="mb-5">
            <Card>
              <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
                <span>{t("header")}</span>
              </Card.Header>

              <Card.Body>
                {detailsActionTemplate}
                <div className="text-end">
                  <Button variant="primary" onClick={onSubmitFunction}>
                    {t("save_changes")}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailsPage;
